<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item
          label="姓名"
          prop="name"
          :rules="[{ required: true, message: '请填写姓名', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          prop="phone"
          :rules="[
            { required: true, message: '请填写手机号码', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if (!value) {
                  return callback(new Error('手机号码不能为空'));
                } else if (!reg.test(value)) {
                  return callback(new Error('手机号格式不正确'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <template v-if="!props.id">
          <el-form-item
            label="密码"
            prop="password"
            :rules="[
              { required: true, message: '请填写密码', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  if (value.length < 6) callback(new Error('密码不能少于6位!'));
                  else callback();
                },
                trigger: 'blur',
              },
            ]"
          >
            <el-input type="password" v-model="state.model.password"></el-input>
            <el-icon style="margin-left: 10px" color="#ffa500">
              <QuestionFilled />
            </el-icon>
            <text style="color: #ffa500; margin-left: 3px" v-if="!props.id">
              密码不少于6位
            </text>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="password_confirm"
            :rules="[
              {
                required: true,
                message: '请填写确认密码',
                trigger: 'blur',
              },
              {
                validator: (rule, value, callback) => {
                  if (value != state.model.password)
                    callback(new Error('两次密码输入不一致'));
                  else callback();
                },
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="password"
              v-model="state.model.password_confirm"
            ></el-input>
            <el-icon style="margin-left: 10px" color="#ffa500">
              <QuestionFilled />
            </el-icon>
            <text style="color: #ffa500; margin-left: 3px" v-if="!props.id">
              密码不少于6位
            </text>
          </el-form-item>
        </template>
        <el-form-item
          label="所属部门"
          prop="department_id"
          :rules="[{ required: true, message: '请选择部门', trigger: 'blur' }]"
        >
          <el-tree-select
            v-model="state.model.department_id"
            :data="state.departmentData"
            node-key="id"
            value-key="id"
            clearable
            accordion
            :props="{ label: 'name' }"
            :render-after-expand="false"
            :highlight-current="true"
            :default-expand-all="true"
            :check-strictly="true"
            placeholder="--所属部门--"
            @clear="delete state.model.department_id"
          >
            <template #default="{ data }">
              <div style="display: flex; align-items: center">
                {{ data.name }}
              </div>
            </template>
            <template #footer>
              <el-button size="small" @click="onLoadTree">刷新</el-button>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="所属角色"
          prop="admin_role_idArr"
          :rules="[{ required: true, message: '请选择角色', trigger: 'blur' }]"
        >
          <el-select
            v-model="state.model.admin_role_idArr"
            style="width: 100%"
            multiple
          >
            <el-option
              v-for="item in state.roleData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadRole()"> 刷新 </el-button>
            </template>
          </el-select>
          <el-icon style="margin-left: 10px" color="#ffa500">
            <WarningFilled />
          </el-icon>
          <text style="color: #ffa500; margin-left: 3px" v-if="!props.id">
            支持多选
          </text>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="[
            {
              validator: (rule, value, callback) => {
                let reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/;
                if (value) {
                  if (!reg.test(value))
                    return callback(new Error('邮箱格式不正确'));
                  else callback();
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.email"></el-input>
        </el-form-item>
        <el-form-item label="审批角色">
          <el-checkbox-group v-model="state.model.approver_type">
            <el-checkbox label="1">业务负责人</el-checkbox>
            <el-checkbox label="2">财务负责人</el-checkbox>
            <el-checkbox label="3">总经理</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="职务">
          <el-input v-model="state.model.job"></el-input>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_department_tree, data_role_select } from "@/http/data";
import { admin_add, admin_edit, admin_detail } from "@/http/admin";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadDepartment();
      onLoadRole();

      if (props.id) {
        admin_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            state.model.admin_role_idArr = state.model.admin_role_ids;
          }
        });
      }
    });

    const onLoadDepartment = () => {
      data_department_tree().then((res) => {
        if (res.status == 200) {
          state.departmentData = res.data.data;
        }
      });
    };

    const onLoadRole = () => {
      data_role_select().then((res) => {
        if (res.status == 200) state.roleData = res.data.data.list;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          state.model.admin_role_ids = state.model.admin_role_idArr.join(",");

          if (props.id) {
            admin_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            admin_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadDepartment,
      onLoadRole,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
